import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setactiveconfirmuser, clearactiveconfirmuser, set_Acc_InProgress, remove_idaustriadataloading, clearidaustria_data,set_get_screenshot} from '../../slice/mainslice'
import { Modal, Text, Button, Grid,Tooltip,Loader } from '@mantine/core';
import { ZoomQuestion,  CircleX, CameraPlus, AccessibleOff } from 'tabler-icons-react';
import IdentConfirmButton from './IdentConfirmButton';
import IdentAustriaConfirmButton from './IdentAustriaConfirmButton';

import ModalMakeScreen from './ModalMakeScreen';
import intl from 'react-intl-universal';
import { notifications } from '@mantine/notifications';
import { isPropertySignature } from 'typescript';
import { Console } from 'console';



const IdentButtons = (props:any ) => {
   const dispatch = useDispatch()
   //const [identinprogress, setidentinprogress] = useState(false);

   const [opened, setOpened] = useState(false);
   const [openeddelete, setOpeneddelete] = useState(false);
   const [removeconfirm, setOpenRemoveConfirm] = useState(false);
   

   const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
   const activeconfirmuser = useSelector((state: any) => state.user.activconfirmuser)
   const idarequestId = useSelector((state: any) => state.user.idAustriadataloading)

   const getscreenshot = useSelector((state: any) => state.user.startscreenshot)

  let identinprogress = false
  let openmoalforscreens = false


    // Sicherstellen das nur das kative Modale Screenshot Fenster sich öffnet
    if(props.meetingParticipantId === activeconfirmuser && props.openscreen === true){
      openmoalforscreens = true
    }
    




  // Conformation Dialog
  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };
  
  const handleYesClick = () => {
    sendconfirmIdentrequest();
    handleClose();
  };

  const handleNoClick = () => {
    handleClose();
  };


  const handleOpenDelete = () => {
    setOpeneddelete(true);
  };

  const handleCloseDelete = () => {
    setOpeneddelete(false);
  };

  const handleDeleteYesClick = () => {
    removeconfirmIdentrequest();
    handleCloseDelete();
  };

  const handleDeleteNoClick = () => {
    handleCloseDelete();
  };


  const handleOpenRemoveConfirm = () => {
    setOpenRemoveConfirm(true);
  };

  const handleCloseRemoveConfirm = () => {
    setOpenRemoveConfirm(false);
  };


  const handleRemoveYesClick = () => {
    resetidaustriaconformation();
    handleCloseRemoveConfirm();
  };

  const handleRemoveNoClick = () => {
    handleCloseRemoveConfirm();
  };
  
  
   // Close Conformation on "no" 
  const closeconfirmIdentrequest = () => {

    const chancleidentszenepayload ={
      meetingId: meetinginfo.id,
      drnId: meetinginfo.drnId,
      meetingParticipantId: props.meetingParticipantId,
      scenarioId: props.scenarioId, 
      sceneId: props.sceneId,
      isDone: props.confirm,
      showuser: false   
  }
    //console.log(chancleidentszenepayload)
    dispatch({ type: 'SIGNALR_SENDCONFIRMUSER', payload: chancleidentszenepayload });
    dispatch(clearactiveconfirmuser())
    dispatch(set_Acc_InProgress(""))

    props.handlesetSelecteduser("")
  }


  // Send WS REQUEST for brin Klient to Szene
  const sendfocusIdentrequest = () => {
    props.handlesetSelecteduser(props.meetingParticipantId)


    dispatch(setactiveconfirmuser(props.meetingParticipantId))

    const identszenepayload = {
      meetingId: meetinginfo.id,
      drnId: meetinginfo.drnId,
      meetingParticipantId: props.meetingParticipantId,
      scenarioId: props.scenarioId, 
      sceneId: props.sceneId,
      showuser: true        
    };
    //console.log(identszenepayload)
     dispatch({ type: 'SIGNALR_REQUESTIDENTSCENE', payload: identszenepayload });
     
     dispatch(set_Acc_InProgress("Identitätsfestfeststellung"))
  }

  const sendconfirmIdentrequest = () => {
  const confirmidentszenepayload ={
      meetingId: meetinginfo.id,
      drnId: meetinginfo.drnId,
      meetingParticipantId: props.meetingParticipantId,
      scenarioId: props.scenarioId, 
      sceneId: props.sceneId,
      isDone: true,
      showuser: false   
  }
  //console.log(confirmidentszenepayload)
  dispatch({ type: 'SIGNALR_SENDCONFIRMUSER', payload: confirmidentszenepayload });
  
  dispatch(clearactiveconfirmuser())
  dispatch(set_Acc_InProgress(""))

  notifications.show({
    title: intl.get('NOTIF_INFO_HEADER'),
    message: intl.get('NOTIF_IDENTITY_SIGNED'),
    withCloseButton: true,
    autoClose: 5000,
  })
  props.handlesetSelecteduser("")
  
}

const removeconfirmIdentrequest = () => {
  const removeconfirmidentszenepayload ={
      meetingId: meetinginfo.id,
      drnId: meetinginfo.drnId,
      meetingParticipantId: props.meetingParticipantId,
      scenarioId: props.scenarioId, 
      sceneId: props.sceneId,
      isDone: false,
      showuser: false   
  }
  //console.log(confirmidentszenepayload)
  dispatch({ type: 'SIGNALR_SENDCONFIRMUSER', payload: removeconfirmidentszenepayload });
  
  dispatch(clearactiveconfirmuser())
  dispatch(set_Acc_InProgress(""))

  notifications.show({
    title: intl.get('NOTIF_INFO_HEADER'),
    message: intl.get('NOTIF_IDENTITY_UNSIGNED'),
    withCloseButton: true,
    autoClose: 5000,
  })

  props.handlesetSelecteduser("")
}

const remove_ida_loading = () => {

  const closepopuppayload = {
    drnId: meetinginfo.drnId,
    meetingParticipantId: props.meetingParticipantId,
    requestId: idarequestId[0].requestId,
  }


  dispatch({ type: 'SIGNALR_CLOSEDRNPOPUP', payload: closepopuppayload });

  const removepayload ={
    meetingParticipantId: props.meetingParticipantId,
  }
  
  dispatch(remove_idaustriadataloading(removepayload))
  
}


const makescreenshot = () => {
  const makescreenshotpayload ={
    drnId: meetinginfo.drnId,
    meetingParticipantId: props.meetingParticipantId, 
}   
//handleOpenscreen();
dispatch({ type: 'SIGNALR_MAKESCREENSHOT', payload: makescreenshotpayload });
dispatch(set_get_screenshot());
}

const getidaustriadata = () => {
  //console.log(props.meetingParticipantId)
  dispatch(clearidaustria_data(props.meetingParticipantId))
  //dispatch(remove_klientidAustriaaccept(props.meetingParticipantId))
  

  const getidaustriapayload ={
    drnId: meetinginfo.drnId,
    meetingParticipantId: props.meetingParticipantId, 
}   
//handleOpenscreen();
 
dispatch({ type: 'SIGNALR_GETIDAUSTRIADATA', payload: getidaustriapayload });
}



const resetidaustriaconformation = () => {
      
  const handleresetidaustriapayload = {
    drnId: meetinginfo.drnId,
    MeetingParticipantId: props.meetingParticipantId,
    IsIdentified: false,
    IdentificationId: null   
  };


 dispatch({ type: 'SIGNALR_IDAUSTRIA_OK', payload: handleresetidaustriapayload });

}






// Deaktiviere Restliche Buttons wenn ein User ist gewählt
let aktivbuttons = false
let disabledopenbuttons = false
if (activeconfirmuser === props.meetingParticipantId){
  aktivbuttons = true
  identinprogress = true
}
if (activeconfirmuser !== props.meetingParticipantId){
  aktivbuttons = true
  identinprogress = false
}
if (activeconfirmuser === ""){
  aktivbuttons = true
  identinprogress = false
}

if (aktivbuttons && !identinprogress){
  //console.log("selecteduser->",props.selectetuser)
  if (props.selectetuser && props.selectetuser !== props.meetingParticipantId) {
    disabledopenbuttons = true;
}
}


//console.log("-------------------")
//console.log("aktivbuttons->",aktivbuttons)
//console.log("identinprogress->",identinprogress)
//console.log("disabledopenbuttons->",disabledopenbuttons)
//console.log("-------------------")


    return (
        <>
        {aktivbuttons && !identinprogress && !disabledopenbuttons &&
         <Tooltip label={intl.get('IDENTBUTTONS_TT_FOCUS')} >
          <span>
           <ZoomQuestion size={38} strokeWidth={1} onClick={() => sendfocusIdentrequest()}/>
          </span>
        </Tooltip> 
        }

      {aktivbuttons && !identinprogress && disabledopenbuttons &&
         <Tooltip label={intl.get('IDENTBUTTONS_TT_FOCUS_INWORK')} >
          <span>
           <ZoomQuestion color="gray" size={38} strokeWidth={0.5}/>
          </span>
        </Tooltip> 
        }

        {identinprogress && aktivbuttons &&
          <>
          {getscreenshot &&
            <Loader color="green" />
          }
          {!getscreenshot &&
          <Tooltip label={intl.get('IDENTBUTTONS_TT_SCREENSHOT')} >
            <span>
              <CameraPlus size={38} strokeWidth={1} color="green" onClick={() => makescreenshot()} />
            </span>
          </Tooltip> 
        }
        {/* Abbruchbutton des Identifikationsschritts */}
        {!props.idaustriaident && props.idaustriaident !== undefined && props.loadidadata &&
        <Tooltip label={intl.get('IDA_LOADER_CANCEL_STARTREQUEST')} >
            <span>
              <AccessibleOff size={38} strokeWidth={1} color="red" onClick={() => remove_ida_loading()} />
            </span>
          </Tooltip> 
         }      
        
        {!props.loadidadata &&
         <IdentAustriaConfirmButton idaustriaident={props.idaustriaident}  getidaustriadata={getidaustriadata} handleOpenRemoveConfirm={handleOpenRemoveConfirm}/>
        }
         
         <IdentConfirmButton confirm={props.confirm} handleOpen={handleOpen} handleOpenDelete={handleOpenDelete} />
          
          
          <Tooltip label={intl.get('IDENTBUTTONS_TT_IDENT_CLOSE')} >
            <span>
              <CircleX size={38} strokeWidth={1} color="gray" onClick={() => closeconfirmIdentrequest() } />
            </span>
          </Tooltip>

        </>
        }


      <Modal
        title=""
        opened={opened}
        onClose={handleClose}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('IDENTCHECK_MODAL_CONF_TEXT')}</Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" variant="light" onClick={handleNoClick}>{intl.get('DIALOG_BUTTON_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 

      <Modal
        title=""
        opened={openeddelete}
        onClose={handleCloseDelete}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('IDENTCHECK_MODAL_CONF_TEXTBACK')}</Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleDeleteYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" variant="light" onClick={handleDeleteNoClick}>{intl.get('DIALOG_BUTTON_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 

      <Modal
        title="Identität Screenshots"
        opened={openmoalforscreens} 
        onClose={props.handleClosescreen}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="auto"
        shadow="sm"
        centered
        >
          <ModalMakeScreen meetingParticipantId={props.meetingParticipantId} drnId={meetinginfo.drnId} />
          <hr />
          <Button fullWidth color="grey" variant="light" onClick={props.handleClosescreen}>Screenshots Fenster schliessen</Button>  
      </Modal>

      <Modal
        title=""
        opened={removeconfirm}
        onClose={handleCloseRemoveConfirm}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('IDA_DATA_CONFIRM_REMOVE')}</Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleRemoveYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" variant="light" onClick={handleRemoveNoClick}>{intl.get('DIALOG_BUTTON_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 

      
    </>
    )
};

export default IdentButtons;